<template>
  <b-modal
    id="deliveryTrackingModal"
    title="배송 조회"
    size="xl"
    hide-footer
    @shown="onShown"
    @hidden="onHidden"
  >
    <div class="delivery-tracking-wrap">
      <iframe
        v-if="deliveryNo"
        name="deliveryTrackingFrame"
        ref="trackingFrame"
        frameborder="0"
        style="width:100%; height:650px; display:block; overflow:auto;"
      ></iframe>
      <div v-else class="delivery-no-data">
        배송 정보가 없습니다.
      </div>
    </div>

    <!-- Sweet Tracker POST 전송용 hidden form -->
    <form
      ref="trackingForm"
      action="https://info.sweettracker.co.kr/tracking/4"
      method="POST"
      target="deliveryTrackingFrame"
      style="display:none;"
    >
      <input type="hidden" name="t_key" :value="SWEET_TRACKER_API_KEY" />
      <input type="hidden" name="t_invoice" :value="deliveryNo" />
      <input type="hidden" name="t_code" :value="deliveryCompanyCd" />
    </form>
  </b-modal>
</template>

<script>
//const SWEET_TRACKER_API_KEY = 'GHHZ83PljauzInPeurDG8g';
const SWEET_TRACKER_API_KEY = 'qdhJb6FH2ggsuj9mmymkew';

export default {
  name: 'DeliveryTrackingModal',
  props: {
    deliveryNo: {
      type: String,
      default: ''
    },
    deliveryCompanyCd: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      SWEET_TRACKER_API_KEY
    };
  },
  methods: {
    onShown() {
      this.$nextTick(() => {
        if (this.deliveryNo && this.$refs.trackingForm) {
          this.$refs.trackingForm.submit();
        }
      });
    },
    onHidden() {
      this.$emit('hidden');
    }
  }
};
</script>

<style scoped>
.delivery-tracking-wrap {
  min-height: 650px;
}
.delivery-no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  font-size: 1.6rem;
  color: #999;
}
</style>